export default {
  render (h) {
    let children = []
    if (!this.customLayout) {
      const self = this
      // render is also called when modal closes
      if (this.formerfields !== undefined) {
        children = this.formerfields.map((field) => {
          return h('former-field', {
            key: `former_${field.key}`,
            ref: field.key,
            class: `field__${field.type}`,
            props: {
              model: self.model,
              form: self.form,
              field: field
            }
          })
        })
      }
    }
    if ('default' in this.$scopedSlots) children.push(this.$scopedSlots.default({ keys: this.keys }))
    return h(this.tag ? this.tag : 'fieldset', children)
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        const target = this.formerfields.length
        let count = 0
        this.formerfields.forEach(field => {
          if (!(field.key in this.form)) {
            count++
            if (target === count) resolve()
            return
          }
          this.$set(this.form[field.key], '$dirty', true)
          let validate
          if (field.key in this.$refs) {
            validate = this.$refs[field.key].validate
          } else {
            this.$children.some(child => {
              if (!('field' in child)) return false
              if (child.field.key === field.key) {
                validate = child.validate
                return true
              }
            })
          }

          if (typeof validate !== 'function') {
            count++
            if (target === count) resolve()
            return
          }

          validate()
            .then(() => {
              count++
              if (target === count) resolve()
            })
            .catch((e) => {
              reject(e)
            })
        })
      })
    }
  },
  props: ['form', 'model', 'formerfields', 'customLayout'],
  computed: {
    keys () {
      const keys = {}
      this.formerfields.forEach(field => {
        keys[field.key] = field
      })
      return keys
    }
  },
  created () {
    // make sure that the 'value' is always set
    this.formerfields.forEach(field => {
      if (typeof this.model[field.key] === 'undefined') this.$set(this.model, field.key, '')
    })

    // set our validation options
    this.$set(this.form, '$errors', {})
    this.$set(this.form, '$valid', true)

    this.$watch('form.$errors', function (val) {
      let valid = true
      Object.keys(this.form.$errors).forEach((key) => {
        const errField = this.form.$errors[key]
        Object.keys(errField).forEach((errKey) => {
          if (errField[errKey]) valid = false
        })
      })
      this.form.$valid = valid
    }, {
      deep: true
    })
  }
}
